'use client';

import { useSearchParams } from 'next/navigation';
import UnifiedMentorshipApplication from '@/components/mentorshipApplication/UnifiedMentorshipApplication';

export default function ApplyClient({ mentorUser }: { mentorUser: any }) {
  const searchParams = useSearchParams();
  const plan = searchParams.get('plan') || 'standard';

  return (
    <UnifiedMentorshipApplication 
      mentorUser={mentorUser} 
      plan={plan}
    />
  );
}
